export default "__VITE_ASSET__D$2sukVe__"